module.exports = __webpack_public_path__ + "img/wyb-icon.928d970.svg";